import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';

class Topbar extends Component {

	constructor(props) {
        super(props);

        this.showLogoutAlert = this._showLogoutAlert.bind(this);
    }

    render() {

    	return (
    		<div id="topbar">
	    		<div className="topbar-content">
	    			<h1 className="logo">
                        <img src="./images/logo_small.png" alt="捷可印"/><span className="logo-subtitle">電子發票後台管理系統</span>
	    			</h1>
                    <div className="action">
                        <div className="button gray button-outline logout" onClick={this.showLogoutAlert}>登出</div>
                    </div>
	    		</div>
    		</div>
    	)
    }

    _showLogoutAlert() {

        this.props.webActions.showLogoutModal();
    }
}

const mapStateToProps = function(state) {
    return {
    };
};

const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(Topbar);


// WEBPACK FOOTER //
// ./src/components/Topbar.js